import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableMultiPayments',
  initialState: false,
  reducers: {
    setEnableMultiPayments(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableMultiPayments } = slice.actions;

export default slice.reducer;
